import React from "react";
import {
  Accordion,
  Col,
  ListGroup,
  Row,
} from "react-bootstrap";
import DeleteSubscriptionModal from "./deleteSubscriptionModal";
import EditSubscription from './editSubscription'
import { IDasSubscription } from "../../common/types/dasTypes";
import { getTemplateType } from './utils';

interface IProps {
    item: IDasSubscription;
    index: number;
    isActive: boolean;
    toggleAccordion: (index: number) => void;
}

const SubscriptionRow = (props: IProps) => {
  const { item, index, isActive, toggleAccordion } = props;

  return (
    <Row key={index.toString()}>
        <Col sm={11}>
          <Accordion activeKey={isActive ? index.toString() : undefined}>
            <Accordion.Item eventKey={index.toString()}>
              <Accordion.Header onClick={() => toggleAccordion(index)}>
                <div className="integration-heading">
                  <div className="integration-list">
                    <ListGroup horizontal>
                      <ListGroup.Item>{`Alert Type (${item.alertType.length})`}</ListGroup.Item>
                      <ListGroup.Item>{item.county}</ListGroup.Item>
                      <ListGroup.Item>{`Groups (${item.groups.length})`}</ListGroup.Item>
                      <ListGroup.Item>{item.needsApproval ? "Needs Approval" : "Automatic"}</ListGroup.Item>
                      <ListGroup.Item>{getTemplateType(item.templateId)}</ListGroup.Item>
                    </ListGroup>
                  </div>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <EditSubscription dasSubscription={item}/>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
        <Col sm={1}>
          <div className="intergration-delete">
            <DeleteSubscriptionModal subscriptionId={item._id}/>
          </div>
        </Col>
    </Row>
  );
};

export default SubscriptionRow;
